import React, { useState } from 'react';

const Count = ({ count }) => (
  <div className="count">
    {count} Result{count === 1 ? '' : 's'}
  </div>
);

export default Count;
